import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import json from '@/_results.json'

export default new Vuex.Store({
    state: {
        environments: null,
        solutions: null,
        strategic:null,
    },
    mutations: {
        setEnvironments(state) {
            state.environments = json.environments
        },
        setSolutions(state) {
            state.setSolutions = json.solutions
        },
        setStrategic(state) {
            state.strategic = json.strategic
        },
    },
    actions: {},
    modules: {}
})
